import cloneDeep from 'lodash/cloneDeep';
import { Signal } from 'typed-signals';
import type { BlockerModel, BlockerState, KnotBlockerState, BlockerType, BlockerMatchParams } from '../../types';
import type { TileStackModel } from '../board/TileStackModel';
import { BlockerConnection } from './BlockerConnection';

let instanceIndex = 0;

export class KnotBlockerModel implements BlockerModel {
  // eslint-disable-next-line no-plusplus
  public readonly id = `knot_${instanceIndex++}`;

  public readonly underTile = false;

  private readonly state: KnotBlockerState;

  public readonly maxHp = 4;

  public readonly connection: BlockerConnection;

  public readonly requestRemoval = new Signal();

  public readonly onModelChanged = new Signal();

  public readonly destructible: boolean = true;

  constructor(
    private readonly stack: TileStackModel,
    state: KnotBlockerState,
  ) {
    this.state = cloneDeep(state);
    this.connection = new BlockerConnection(this.stack, this.state);
    this.connection.onChange.connect(() => {
      this.onModelChanged.emit();
    });
  }

  public onMatch({ stack, distantMatch }: BlockerMatchParams): void {
    const isNeighbour = stack.getConnectedStacks().some((neighbourOfMatch) => neighbourOfMatch === this.stack);
    if (!isNeighbour && !distantMatch) return;

    this.state.hp -= 1;
    if (this.state.hp <= 0) {
      this.requestRemoval.emit();
    } else {
      this.onModelChanged.emit();
    }
  }

  public getType(): BlockerType {
    return this.state.type;
  }

  public getHp(): number {
    return this.state.hp;
  }

  public setHp(hp: number): void {
    this.state.hp = hp;
    this.onModelChanged.emit();
  }

  public exportState(): BlockerState {
    return this.state;
  }
}
